import { FC, ReactNode } from 'react';
import cx from 'classnames/bind';

import { Points } from '@/components/Points';

import styles from './PointsInfo.module.scss';

interface PointsInfoProps {
  text: string;
  points?: number;
  children?: ReactNode;
  className?: string;
}

const cn = cx.bind(styles);

const PointsInfo: FC<PointsInfoProps> = ({
  text,
  points,
  children,
  className,
}) => (
  <div className={cn('container')}>
    {children}
    <div className={cn('wrapper')}>
      <span className={cn(className || '')}>{text}</span>
      {points !== undefined && <Points points={points} />}
    </div>
  </div>
);

export default PointsInfo;
